import { CopyButton } from '../components/ui/CopyButton.tsx';
import { dialog } from '../components/ui/Dialog.tsx';
import { post } from './api.ts';
import { fmtDateTime } from './date.ts';

/**
 * 플랫폼 관리자의 임시 비밀번호 발급 (CR-034). 사유 입력 → 발급 → 결과를 한 번만 보여 준다(닫으면 다시 볼 수 없음).
 * url: '/platform/operators/:id/password/temporary' | '/platform/tenants/:tid/users/:id/password/temporary'
 */
export async function issueTemporaryPassword(url: string, who: string, invited = false) {
  const lead = invited ? `${who} 는 아직 초대를 수락하지 않은 계정입니다. 임시 비밀번호를 발급하면 초대 메일 없이 바로 활성화되고, 미사용 초대 링크는 무효가 됩니다. 사유를 적으세요.` : `${who} 에게 임시 비밀번호를 발급합니다. 사유를 적으세요.`;
  const reason = await dialog.prompt(`${lead}\n\n발급하면 기존 세션이 모두 종료되고, 사용자는 24시간 안에 이 비밀번호로 로그인해 새 비밀번호를 정해야 합니다. 비밀번호는 이 화면에 한 번만 표시됩니다.`, { title: invited ? '임시 비밀번호로 활성화' : '임시 비밀번호 발급', placeholder: invited ? '예: 초대 메일 미수신, 본인 확인 후' : '예: 본인 확인 후 전화 요청', okText: invited ? '활성화·발급' : '발급' });
  if (reason == null) return false;
  if (reason.trim().length < 2) { await dialog.alert('사유를 2자 이상 적어야 합니다'); return false; }
  const r = await post<{ password: string; expiresAt: string }>(url, { reason: reason.trim() });
  await dialog.alert(<TempPasswordResult password={r.password} expiresAt={r.expiresAt} who={who} />, { title: '임시 비밀번호 (1회 표시)' });
  return true;
}

function TempPasswordResult({ password, expiresAt, who }: { password: string; expiresAt: string; who: string }) {
  return (
    <div>
      <div className="text-[12.5px] text-slate-600">{who} 의 임시 비밀번호입니다. 별도 채널(전화·메신저)로 본인에게 전달하세요.</div>
      <div className="mt-2 flex items-center gap-2">
        <code className="flex-1 border border-slate-300 bg-slate-50 px-2 py-1 font-mono text-[14px] tracking-wider select-all">{password}</code>
        <CopyButton value={password} variant="secondary" />
      </div>
      <div className="mt-2 text-[12px] text-slate-500">만료: {fmtDateTime(expiresAt)} · 첫 로그인 시 비밀번호 변경이 강제됩니다</div>
      <div className="mt-1 text-[12px] text-red-700">이 창을 닫으면 다시 볼 수 없습니다. 필요하면 다시 발급하세요.</div>
    </div>
  );
}
